import { connect } from 'react-redux';

import { getMappingUpdatingCode } from '../../../reducers/analyticsApp';
import {
  cancelUpdateMappingCode,
  changeMappingCode,
  updateMappingCode,
} from '../../../actions/mapping';
import MappingUpdatePane from '../../../components/mapping/manual/UpdatePane';

const mapStateToProps = (state) => ({
  code: getMappingUpdatingCode(state),
});

const mapDispatchToProps = {
  onChange: changeMappingCode,
  onSave: updateMappingCode,
  onCancel: cancelUpdateMappingCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingUpdatePane);
